module.exports = __webpack_public_path__ + "pcstatic/img/zhenti.4b6e438.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/zhenti.png
// module id = SUW2
// module chunks = 34